import { useQuery } from "@apollo/client";
import { graphql } from "../gql";
import { getFragmentData } from "../gql/fragment-masking";

const BulkClassRoomCreationIntentFragment = graphql(`
  fragment BulkClassRoomCreationIntent on BulkClassRoomCreationIntent {
    id
    createdAt
    startDate
    numberOfWeeks
    maxClassRoomNumber
    user1on1ClassroomPlanToBeRedeemedId
    teacher {
      id
      givenName
      familyName
    }
    user {
      id
      givenName
      familyName
    }
    weekSlots {
      dayOfWeek
      startTime
      endTime
    }
  }
`);

const GetAllBulkClassRoomCreationIntentsQuery = graphql(`
  query getAllBulkClassRoomCreationIntents($limit: Int!, $offset: Int!) {
    getAllBulkClassRoomCreationIntents(limit: $limit, offset: $offset) {
      ...BulkClassRoomCreationIntent
    }
  }
`);

export const useGetAllBulkClassRoomCreationIntents = (
  limit: number,
  offset: number,
) => {
  const { data, loading, error } = useQuery(
    GetAllBulkClassRoomCreationIntentsQuery,
    {
      variables: { limit, offset },
      fetchPolicy: "cache-and-network",
    },
  );

  const intents = getFragmentData(
    BulkClassRoomCreationIntentFragment,
    data?.getAllBulkClassRoomCreationIntents ?? [],
  );

  return { intents, loading, error };
};
